import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a16e29da from 'nuxt_plugin_plugin_a16e29da' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_configpluginripplef6d7c560_45cae670 from 'nuxt_plugin_configpluginripplef6d7c560_45cae670' // Source: ./config.plugin-ripple.f6d7c560.js (mode: 'all')
import nuxt_plugin_axios_3f1c135e from 'nuxt_plugin_axios_3f1c135e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuefragment_09778d2d from 'nuxt_plugin_vuefragment_09778d2d' // Source: ../plugins/vue-fragment (mode: 'all')
import nuxt_plugin_axios_f5846aac from 'nuxt_plugin_axios_f5846aac' // Source: ../plugins/axios.runtime (mode: 'all')
import nuxt_plugin_amcharts_e55244c0 from 'nuxt_plugin_amcharts_e55244c0' // Source: ../plugins/amcharts.js (mode: 'client')
import nuxt_plugin_aggrid_7a78a755 from 'nuxt_plugin_aggrid_7a78a755' // Source: ../plugins/aggrid.js (mode: 'client')
import nuxt_plugin_apiv2_356def40 from 'nuxt_plugin_apiv2_356def40' // Source: ../plugins/apiv2 (mode: 'client')
import nuxt_plugin_chat_6a7f03ce from 'nuxt_plugin_chat_6a7f03ce' // Source: ../plugins/chat (mode: 'client')
import nuxt_plugin_datadogclient_20227ffa from 'nuxt_plugin_datadogclient_20227ffa' // Source: ../plugins/datadog.client.js (mode: 'client')
import nuxt_plugin_primevue_67a110ba from 'nuxt_plugin_primevue_67a110ba' // Source: ../plugins/primevue.js (mode: 'client')
import nuxt_plugin_compositionapi_a8f56dd4 from 'nuxt_plugin_compositionapi_a8f56dd4' // Source: ../plugins/composition-api.js (mode: 'client')
import nuxt_plugin_momentsetup_21891d51 from 'nuxt_plugin_momentsetup_21891d51' // Source: ../plugins/moment-setup.js (mode: 'client')
import nuxt_plugin_profileactivitytracker_e7b3143a from 'nuxt_plugin_profileactivitytracker_e7b3143a' // Source: ../plugins/profile-activity-tracker.js (mode: 'client')
import nuxt_plugin_auth_9fbdb682 from 'nuxt_plugin_auth_9fbdb682' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Portal | NuvoAir","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"robots","name":"robots","content":"noindex"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.15.1\u002Fcss\u002Fall.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans:wght@300;400;600;700&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto+Mono:wght@500&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a16e29da === 'function') {
    await nuxt_plugin_plugin_a16e29da(app.context, inject)
  }

  if (typeof nuxt_plugin_configpluginripplef6d7c560_45cae670 === 'function') {
    await nuxt_plugin_configpluginripplef6d7c560_45cae670(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3f1c135e === 'function') {
    await nuxt_plugin_axios_3f1c135e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefragment_09778d2d === 'function') {
    await nuxt_plugin_vuefragment_09778d2d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_f5846aac === 'function') {
    await nuxt_plugin_axios_f5846aac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amcharts_e55244c0 === 'function') {
    await nuxt_plugin_amcharts_e55244c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aggrid_7a78a755 === 'function') {
    await nuxt_plugin_aggrid_7a78a755(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apiv2_356def40 === 'function') {
    await nuxt_plugin_apiv2_356def40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chat_6a7f03ce === 'function') {
    await nuxt_plugin_chat_6a7f03ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogclient_20227ffa === 'function') {
    await nuxt_plugin_datadogclient_20227ffa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_primevue_67a110ba === 'function') {
    await nuxt_plugin_primevue_67a110ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_compositionapi_a8f56dd4 === 'function') {
    await nuxt_plugin_compositionapi_a8f56dd4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_momentsetup_21891d51 === 'function') {
    await nuxt_plugin_momentsetup_21891d51(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_profileactivitytracker_e7b3143a === 'function') {
    await nuxt_plugin_profileactivitytracker_e7b3143a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_9fbdb682 === 'function') {
    await nuxt_plugin_auth_9fbdb682(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
